function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import RPT from 'prop-types';
/**
* Create a wrapper which sets default onion-properties from context on a field
* @param {string} name - name of content extractor
* @return {function} function which accepts field component to be decorated
*/

export default function createContextExtractor(name) {
  return function (Field) {
    var FormFieldWrapper = /*#__PURE__*/function (_Component) {
      _inherits(FormFieldWrapper, _Component);

      function FormFieldWrapper() {
        _classCallCheck(this, FormFieldWrapper);

        return _possibleConstructorReturn(this, _getPrototypeOf(FormFieldWrapper).apply(this, arguments));
      }

      _createClass(FormFieldWrapper, [{
        key: "render",
        value: function render() {
          var _this$context = this.context,
              onionFormName = _this$context.onionFormName,
              onionFieldRegister = _this$context.onionFieldRegister,
              onionLiveValidate = _this$context.onionLiveValidate,
              onionOnSubmit = _this$context.onionOnSubmit,
              onionValidateField = _this$context.onionValidateField,
              onionFormIsDirty = _this$context.onionFormIsDirty;
          return React.createElement(Field, _extends({}, this.props, {
            onionFieldRegister: onionFieldRegister,
            onionFormName: onionFormName,
            onionLiveValidate: onionLiveValidate,
            onionFormIsDirty: onionFormIsDirty,
            onionValidateField: onionValidateField,
            onionOnSubmit: onionOnSubmit
          }));
        }
      }]);

      return FormFieldWrapper;
    }(Component);

    _defineProperty(FormFieldWrapper, "contextTypes", {
      onionFieldRegister: RPT.func.isRequired,
      onionFormName: RPT.string.isRequired,
      onionLiveValidate: RPT.func.isRequired,
      onionFormIsDirty: RPT.func.isRequired,
      onionOnSubmit: RPT.func.isRequired,
      onionValidateField: RPT.func.isRequired
    });

    _defineProperty(FormFieldWrapper, "displayName", "Form".concat(name, "ContextExtractor"));

    return FormFieldWrapper;
  };
}